import { useRequest } from 'features/request/useRequest';
import type { ChapterEnum, UerClassifierEnum } from 'gql/graphql';

import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { setCatalogUERBaseCostPropertiesGql } from '../../../catalogUerBaseCostQueries';

export interface IUpdateCatalogUerBaseCostPropertiesForm {
    uerClassifier: { id: UerClassifierEnum; label: string };
    chapter: { id: ChapterEnum; label: string };
}

export interface IUseSetCatalogUerBaseCostPropertiesProps {
    catalogId?: number;
    checkedRowIds: number[];
    resetCheckedRows: () => void;
    refreshTable: () => void;
}

export const useSetCatalogUerBaseCostProperties = ({
    catalogId,
    checkedRowIds,
    refreshTable,
    resetCheckedRows,
}: IUseSetCatalogUerBaseCostPropertiesProps) => {
    const dispatch = useDispatch();

    const onSuccess = useCallback(() => {
        resetCheckedRows();
        refreshTable();
    }, [resetCheckedRows, refreshTable]);

    const [, , , request] = useRequest({
        requestId: 'setCatalogUERBaseCostProperties',
        query: setCatalogUERBaseCostPropertiesGql,
        withEffect: false,
        dependenciesUpdater: onSuccess,
    });

    const makeRequest = useCallback(
        (formValues: IUpdateCatalogUerBaseCostPropertiesForm) => {
            dispatch(
                request({
                    catalogId,
                    input: {
                        uerIds: checkedRowIds,
                        chapter: formValues?.chapter?.id,
                        uerClassifier: formValues?.uerClassifier?.id,
                    },
                }),
            );
        },
        [catalogId, checkedRowIds, dispatch, request],
    );

    return {
        makeRequest,
    };
};
